import type { AvatarProps, AvatarSize } from "./types";

const sizeClasses: Record<AvatarSize, { container: string; text: string }> = {
  xs: { container: "h-5 w-5", text: "text-[8px]" },
  sm: { container: "h-6 w-6", text: "text-[9px]" },
  md: { container: "h-7 w-7", text: "text-[10px]" },
  lg: { container: "h-8 w-8", text: "text-[11px]" },
};

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

export function Avatar({
  name,
  avatarUrl,
  avatarColor = "#E8734A",
  size = "md",
  ring = false,
  className = "",
}: AvatarProps) {
  const s = sizeClasses[size];
  const ringClass = ring ? "ring-2 ring-surface" : "";

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={name}
        className={`${s.container} rounded-full object-cover shrink-0 ${ringClass} ${className}`}
      />
    );
  }

  return (
    <div
      className={`${s.container} rounded-full flex items-center justify-center ${s.text} font-semibold text-white shrink-0 ${ringClass} ${className}`}
      style={{ backgroundColor: avatarColor }}
    >
      {getInitials(name)}
    </div>
  );
}
